import React from "react";
import {getMenus} from "./ClientMenuQueries";
import PageTitle from "../../../layout/PageTitle";
import {useQuery} from "@apollo/client";
import {tableImageTag} from "../../../helpers/Api";
import {Container} from "react-bootstrap";
import ListTable from "../../shared/ListTable";
import {ViewButton} from "../../../helpers/ButtonHelper";
import {Link} from "react-router-dom";
import Loader from "../../shared/Loader";

const ClientMenusList = () => {
  const { data, loading } = useQuery(getMenus)

  const header = <tr>
    <th>Denumire</th>
    {/*<th className="d-sm-table-cell d-none w-50">Detalii</th>*/}
    <th>Mese</th>
    <th className="d-sm-table-cell d-none">Provider</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/my_menus/${item.id}`}>
          {tableImageTag(item, { type: 'menu' })}
          {item.name}
        </Link>
      </td>
      {/*<td className="d-sm-table-cell d-none w-50">{truncateString(item.details, 100)}</td>*/}
      <td>{item.platesCount}</td>
      <td className="d-sm-table-cell d-none">
        {tableImageTag(item.provider, { type: 'avatar', src: item.provider.avatar })}
        {item.provider.fullName}
      </td>
      <td className='actions'>
        <ViewButton to={`/my_menus/${item.id}`} />
      </td>
    </tr>
  }

  return (
    <Container>
      <PageTitle title='Meniuri' />
      <div className="row justify-content-md-center">
        <div className="page-container col">
          {!loading ?
            <ListTable data={data && data.activeMenus} header={header} listItem={listItem} showSearch={false} />
            :
            <Loader />
          }
        </div>
      </div>
    </Container>
  )
};

export default ClientMenusList;
